/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sights_Sounds_FromInputs */

const en_sights_sounds_from = /** @type {(inputs: Sights_Sounds_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sights & Sounds from`)
};

/** @type {(inputs: Sights_Sounds_FromInputs) => LocalizedString} */
const es_sights_sounds_from = en_sights_sounds_from;

/** @type {(inputs: Sights_Sounds_FromInputs) => LocalizedString} */
const fr_sights_sounds_from = en_sights_sounds_from;

/** @type {(inputs: Sights_Sounds_FromInputs) => LocalizedString} */
const de_sights_sounds_from = en_sights_sounds_from;

/** @type {(inputs: Sights_Sounds_FromInputs) => LocalizedString} */
const ja_sights_sounds_from = en_sights_sounds_from;

/** @type {(inputs: Sights_Sounds_FromInputs) => LocalizedString} */
const zh_sights_sounds_from = en_sights_sounds_from;

/** @type {(inputs: Sights_Sounds_FromInputs) => LocalizedString} */
const ar_sights_sounds_from = en_sights_sounds_from;

/** @type {(inputs: Sights_Sounds_FromInputs) => LocalizedString} */
const id_sights_sounds_from = en_sights_sounds_from;

/** @type {(inputs: Sights_Sounds_FromInputs) => LocalizedString} */
const it_sights_sounds_from = en_sights_sounds_from;

/** @type {(inputs: Sights_Sounds_FromInputs) => LocalizedString} */
const ru_sights_sounds_from = en_sights_sounds_from;

/** @type {(inputs: Sights_Sounds_FromInputs) => LocalizedString} */
const pt_sights_sounds_from = en_sights_sounds_from;

/** @type {(inputs: Sights_Sounds_FromInputs) => LocalizedString} */
const ko_sights_sounds_from = en_sights_sounds_from;

/**
* | output |
* | --- |
* | "Sights & Sounds from" |
*
* @param {Sights_Sounds_FromInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sights_sounds_from = /** @type {((inputs?: Sights_Sounds_FromInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sights_Sounds_FromInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sights_sounds_from(inputs)
	if (locale === "es") return es_sights_sounds_from(inputs)
	if (locale === "fr") return fr_sights_sounds_from(inputs)
	if (locale === "de") return de_sights_sounds_from(inputs)
	if (locale === "ja") return ja_sights_sounds_from(inputs)
	if (locale === "zh") return zh_sights_sounds_from(inputs)
	if (locale === "ar") return ar_sights_sounds_from(inputs)
	if (locale === "id") return id_sights_sounds_from(inputs)
	if (locale === "it") return it_sights_sounds_from(inputs)
	if (locale === "ru") return ru_sights_sounds_from(inputs)
	if (locale === "pt") return pt_sights_sounds_from(inputs)
	return ko_sights_sounds_from(inputs)
});